import Vue from 'vue'
import App from './App.vue'
import Buefy from 'buefy'
import { VueContext } from 'vue-context'
import store from './store'
import router from './router'
import VueLogger from 'vuejs-logger'
import i18n from './i18n'
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import * as VeeValidate from 'vee-validate'
import VueCookies from 'vue-cookies'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUser, faUsers, faKey } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Logger system
const options = {
  // optional : defaults to true if not specified
  isEnabled: true,
  // required ['debug', 'info', 'warn', 'error', 'fatal']
  logLevel: 'debug',
  // optional : defaults to false if not specified
  stringifyArguments: true,
  // optional : defaults to false if not specified
  showLogLevel: true,
  // optional : defaults to false if not specified
  showMethodName: true,
  // optional : defaults to '|' if not specified
  separator: '|',
  // optional : defaults to false if not specified
  showConsoleColors: true
}

// VueMoment: Moment JS to manage time
Vue.use(VueMoment, { moment })

// Buefy: Framewor   CSS
Vue.use(Buefy)
Vue.use(VueLogger, options)
Vue.use(VueContext)
Vue.use(VeeValidate)
Vue.use(VueCookies)

// Font awesome icons
library.add(faUser, faUsers, faKey)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

if (window.top !== window.self) {
  document.domain = 'acuity-cloud.com'
}

new Vue({
  router,
  store,
  i18n,
  VueMoment,
  render: h => h(App)
}).$mount('#app')
